module.exports = "<p>update-picture works!</p>\r\n"